export function BPMmarker() {
  return (
    <i
      style={{
        display: 'inline-block',
        width: 32,
        height: 32,
      }}
    >
      <img
        src={'/marker__custom.png'}
        alt='Logo del partner "Custom"'
        width={'100%'}
        height={'100%'}
        style={{
          objectFit: 'contain',
        }}
      />
    </i>
  )
}
